import { render, staticRenderFns } from "./InstallBanner.vue?vue&type=template&id=621aee3f&"
import script from "./InstallBanner.vue?vue&type=script&lang=ts&"
export * from "./InstallBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports